export default __webpack_public_path__ + "static/media/virtualManager.5a6a7f3f.svg";